import React from 'react';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
import { createTheme } from '../../utils/createTheme';
const theme = createTheme();
const Example = ({
  isDo,
  children,
  desc
}) => React.createElement(Box, null, React.createElement(Box, {
  p: 3,
  mb: 2,
  borderRadius: 'xl',
  style: {
    display: 'grid',
    placeItems: 'center',
    border: `1px solid ${theme.palette.border.base}`,
    borderTop: `5px solid ${isDo ? theme.palette.success.base : theme.palette.error.base}`,
    aspectRatio: '2.5'
  }
}, children), React.createElement(Text.span, null, React.createElement(Text.span, {
  bold: true
}, isDo ? 'DO ' : "DON'T "), desc));
/**
 * @public
 */
export const DoDont = ({
  doExample,
  dontExample,
  doText,
  dontText
}) => React.createElement(Box, {
  my: 4,
  style: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: `repeat(2, 1fr)`,
    gap: theme.space[3]
  }
}, React.createElement(Example, {
  desc: doText,
  isDo: true
}, doExample), React.createElement(Example, {
  desc: dontText
}, dontExample));